<template>
  <v-layout>
    <v-flex>
      <v-layout align-center>
        <!-- Title -->
        <v-flex class="display-1 blue-grey--text font-weight-light"
          >QMatchingItems similares</v-flex
        >
        <!-- Sort options -->
        <!-- <v-flex shrink>
          <v-similar-order-button order-by="bimodal" />
        </v-flex>
        <v-flex shrink>
          <v-similar-order-button order-by="text" />
        </v-flex>
        <v-flex shrink>
          <v-similar-order-button order-by="visual" />
        </v-flex> -->
        <v-flex shrink>
          <v-similar-order-button order-by="sql" />
        </v-flex>
      </v-layout>
      <v-layout class="my-2">
        <v-flex>
          <v-divider />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("matching");

import VSimilarOrderButton from "./SimilarOrderButton";

export default {
  components: {
    VSimilarOrderButton,
  },
  computed: {
    ...mapState(["similarItems"]),
  },
};
</script>
